import React, { Component, PropTypes } from 'react';
import $ from 'jquery';
import { ItemTypes } from '../constants';
import { DropTarget } from 'react-dnd';
import ZonePointList from './ZonePointList';

const planTarget = {
  drop(props, monitor, component) {
    const { point } = monitor.getItem();
    const { x, y } = monitor.getClientOffset();

    const scrolltop = $(window).scrollTop();
    const { top, left, height, width } = component._imageMeta;

    const pointTop = ((((y + scrolltop - top) * 100) / height) * 100).toFixed(
      0
    );
    const pointLeft = ((((x - left) * 100) / width) * 100).toFixed(0);

    props.onPlacePoint(point, pointTop, pointLeft);
  },
};

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
});

const computeImage = img => {
  const { clientWidth, clientHeight } = img;
  const position = $(img).offset();

  return {
    top: position.top,
    left: position.left,
    height: clientHeight,
    width: clientWidth,
  };
};

class ZoneImage extends Component {
  constructor(props) {
    super(props);

    this._setImage = this._setImage.bind(this);
  }

  // TODO: Handling window resizes
  componentDidMount() {
    this._image.onload = evt => {
      // Computing ratio
      this._imageMeta = computeImage(evt.currentTarget);
    };
  }

  _setImage(ref) {
    this._image = ref;
  }

  render() {
    const { zone, points, connectDropTarget, onDisplayPoint } = this.props;

    return connectDropTarget(
      <div className="plan">
        <ZonePointList
          points={points}
          onDisplayPoint={onDisplayPoint}
          taskType={zone.task_type}
        />
        <img ref={this._setImage} src={zone.image.xhdpi} alt="Plan" />
      </div>
    );
  }
}

ZoneImage.propTypes = {
  zone: PropTypes.object.isRequired,
  points: PropTypes.array.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  onPlacePoint: PropTypes.func.isRequired,
  onDisplayPoint: PropTypes.func.isRequired,
};

export default DropTarget(ItemTypes.POINT, planTarget, collect)(ZoneImage);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/ZoneImage.js